import React, { useState } from 'react';
import './Contact.css';

const Contact = () => {
  const [form, setForm] = useState({ name: '', email: '', company: '', message: '', service: '' });
  const [status, setStatus] = useState('idle');

  const services = ['aXtion Telemed', 'aXtion EHR Systems', 'aXtion Students Portal', 'Fintech Integration', 'Enterprise Software Solutions', 'IT Management', 'Cyber Security'];

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('sending');
    try {
      const apiBase = process.env.REACT_APP_API_URL || '';
      const res = await fetch(`${apiBase}/api/contact`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });
      if (res.ok) {
        setStatus('sent');
        setForm({ name: '', email: '', company: '', message: '', service: '' });
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    }
  };

  return (
    <section id="contact" className="contact">
      <div className="contact-inner">
        <div className="contact-left fade-up">
          <span className="section-label">// 05 — Get In Touch</span>
          <h2 className="contact-title">
            Get a Free<br />
            Consultation<br />
            <em>today</em>
          </h2>
          <div className="contact-info">
            <div className="info-item">
              <span className="info-label">Email</span>
              <a href="mailto:info@axtiontechnologies.com">info@axtiontechnologies.com</a>
            </div>
            <div className="info-item">
              <span className="info-label">Emergency</span>
              <a href="tel:+17035777500">+1 703-577-7500</a>
            </div>
            <div className="info-item">
              <span className="info-label">Office</span>
              <span>Stafford, VA and Freetown SL</span>
            </div>
            <div className="info-item">
              <span className="info-label">Hours</span>
              <span className="highlight">8:00 AM – 7:45 PM</span>
            </div>
          </div>
        </div>

        <form className="contact-form fade-up" onSubmit={handleSubmit}>
          <div className="form-row">
            <div className="form-field">
              <label htmlFor="name">Name *</label>
              <input id="name" name="name" type="text" value={form.name} onChange={handleChange} required placeholder="Jane Smith" />
            </div>
            <div className="form-field">
              <label htmlFor="email">Email *</label>
              <input id="email" name="email" type="email" value={form.email} onChange={handleChange} required placeholder="jane@company.com" />
            </div>
          </div>
          <div className="form-field">
            <label htmlFor="company">Company</label>
            <input id="company" name="company" type="text" value={form.company} onChange={handleChange} placeholder="Acme Corp" />
          </div>
          <div className="form-field">
            <label htmlFor="service">Service Area</label>
            <select id="service" name="service" value={form.service} onChange={handleChange}>
              <option value="">Select a service...</option>
              {services.map(s => (
                <option key={s} value={s}>{s}</option>
              ))}
            </select>
          </div>
          <div className="form-field">
            <label htmlFor="message">Message *</label>
            <textarea
              id="message"
              name="message"
              value={form.message}
              onChange={handleChange}
              required
              rows={5}
              placeholder="Tell us about your project or how we can help..."
            />
          </div>

          <button type="submit" className="submit-btn" disabled={status === 'sending'}>
            {status === 'sending' ? 'Sending...' : status === 'sent' ? '✓ Message Sent' : 'Send Message →'}
          </button>

          {status === 'error' && (
            <p className="form-error">Something went wrong. Please email us directly.</p>
          )}
        </form>
      </div>
    </section>
  );
};

export default Contact;
